__webpack_require__.p = "https://rscdn.qmai.com/catering-h5-international/62f08a7/";